import React from "react";
import { Box, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import { TopAccountBar } from "../components/InfoBar/components/TopAccountBar/TopAccountBar.view";
import { useResponsive } from "../hooks/useResponsive";
import { SideTabBar } from "../components/SideTabBar/SideTabBar.view";
import * as Styles from "./AccountLayout.styles";
import { getColors } from "../../src/utils/style";
import Footer from "../components/Footer";
export const AccountLayout = () => {
  const theme = useTheme();
  useResponsive();
  return (
    <Box>
      <Box sx={{ ...Styles.container, bgcolor: getColors().bglightgrey }}>
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            flexShrink: 0,
            zIndex: 10,
          }}
        >
          <TopAccountBar />
        </Box>
        <Box sx={Styles.contentWrapper}>
          <Box>
            <SideTabBar />
          </Box>
          <Box sx={Styles.outletWrapper}>
            <Outlet />
          </Box>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};
